import React, {PureComponent as Component} from 'react';
import KickImage from 'Reuseables/KickImage';
import { Row, Col } from 'reactstrap';
import propTypes from 'prop-types';
import classnames from 'classnames';
import PreVerified from '../../../../images/pre_verified.png';

const Size = ({ otherSize, submitSize, sell }) => (
  <Row style={{paddingLeft: '15px'}} className="row-checkoutsize">
    {
      otherSize.map(item => (
        <Col key={item.id} className="size-list">
          <div className="size-item checkout">
            <div 
              style={{ visibility: !item.pre_verified? 'hidden' : 'visible' }}
              className="wrapper-pre_verified"
            >
              <KickImage src={PreVerified} />
            </div>
            <p
              onClick={() => submitSize(item)} 
              className={classnames({'selected': item.id === sell.id})}
            >
              {
                item.size_id &&
                item.size.US === undefined ? '-' : item.size.US
              }
            </p>
          </div>
        </Col>
      ))
    }
  </Row>
)

Size.propTypes={
    US:propTypes.any.isRequired
}
Size.defaultProps={
    US:0
}

export default Size;